import React from "react"
import { Box, Stack, Link, Typography } from "@mui/material"
import { useMusicStore } from "../store/store"
import { PlayModes } from "../../types/PlayModes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBrain, faPaintBrush, faShuffle, faSortAmountAsc, faStopCircle } from "@fortawesome/free-solid-svg-icons";

const JukeboxSelector = () => {
    const { playMode, setPlayMode } = useMusicStore();
    
    return (
        <Stack display="flex" flexDirection="row" gap={2}>
            <Box>
                <Typography variant="subtitle2">
                    Jukebox Selector:
                </Typography>
            </Box>
            <Box>
                <Typography variant="subtitle2">
                    <Link
                        onClick={playMode !== PlayModes.NoRules ? () => setPlayMode(PlayModes.NoRules) : undefined}
                        color="inherit"
                        component="button"
                        underline="none"
                        sx={playMode === PlayModes.NoRules ? { color: 'skyblue', cursor: 'default', pointerEvents: 'none' } : {}}
                    >
                        <FontAwesomeIcon icon={faShuffle} className="icon" />
                        Crazy
                    </Link>
                </Typography>
            </Box>
            <Box>
                <Typography variant="subtitle2">
                    <Link
                        onClick={playMode !== PlayModes.AiGenerated ? () => setPlayMode(PlayModes.AiGenerated) : undefined}
                        color="inherit"
                        component="button"
                        underline="none"
                        sx={
                            playMode === PlayModes.AiGenerated
                                ? { color: 'skyblue', cursor: 'default', pointerEvents: 'none' }
                                : {}
                        }
                    >
                        <FontAwesomeIcon icon={faBrain} className="icon" />
                        Smart
                    </Link>
                </Typography>
            </Box>
            <Box>
                <Typography variant="subtitle2">
                    <Link
                        onClick={playMode !== PlayModes.Similar ? () => setPlayMode(PlayModes.Similar) : undefined}
                        color="inherit"
                        component="button"
                        underline="none"
                        sx={
                            playMode === PlayModes.Similar
                                ? { color: 'skyblue', cursor: 'default', pointerEvents: 'none' }
                                : {}
                        }
                    >
                        <FontAwesomeIcon icon={faPaintBrush} className="icon" />
                        Similar
                    </Link>
                </Typography>
            </Box>
            <Box>
                <Typography variant="subtitle2">
                    <Link
                        onClick={playMode !== PlayModes.Queue ? () => setPlayMode(PlayModes.Queue) : undefined}
                        color="inherit"
                        component="button"
                        underline="none"
                        sx={
                            playMode === PlayModes.Queue
                                ? { color: 'skyblue', cursor: 'default', pointerEvents: 'none' }
                                : {}
                        }
                    >
                        <FontAwesomeIcon icon={faSortAmountAsc} className="icon" />
                        Queue
                    </Link>
                </Typography>
            </Box>
            <Box>
                <Typography variant="subtitle2">
                    <Link
                        onClick={playMode !== PlayModes.Unknown ? () => setPlayMode(PlayModes.Unknown) : undefined}
                        color="inherit"
                        component="button"
                        underline="none"
                        sx={
                            playMode === PlayModes.Unknown
                                ? { color: 'skyblue', cursor: 'default', pointerEvents: 'none' }
                                : {}
                        }
                    >
                        <FontAwesomeIcon icon={faStopCircle} className="icon" />
                        Stop
                    </Link>
                </Typography>
            </Box>
        </Stack>
    )
}

export default JukeboxSelector;